var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { Link } from './link';
var PrimaryStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: transparent;\n  text-decoration: none;\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: ", ";\n  }\n\n  &:focus-visible {\n    color: ", ";\n    outline: none;\n  }\n\n  &:active {\n    color: ", ";\n    text-decoration: ", ";\n  }\n"], ["\n  color: ", ";\n  background-color: transparent;\n  text-decoration: none;\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: ", ";\n  }\n\n  &:focus-visible {\n    color: ", ";\n    outline: none;\n  }\n\n  &:active {\n    color: ", ";\n    text-decoration: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (disabled ? theme.colors.neutral7 : theme.colors.primary);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.65 : 1);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryDark;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'underline');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'underline');
});
var Primary = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), PrimaryStyles);
export default Primary;
var templateObject_1, templateObject_2;
//# sourceMappingURL=primary.js.map